/**
 * @ngdoc component
 * @name common.shopCart.component:ItxShopCart
 * @description
 *
 * Shop cart component.
 *
 * @param {object} shopCart - Shopcart object
 */
 (function () {
    'use strict';

    var ItxShopCartCmp = {
        bindings: {
            shopCart: '<',
            editable: '<',
            checkTailoring: '<',
            checkReturnableItems: '<',
            hasNoReturnableItems: '=',
            isAuthenticated: '<'
        },
        controller: ItxShopCartCmpCtrl,
        templateUrl: 'shop-cart.component.html'
        // templateUrl: ['$attrs', function ($attrs) {
        //     return $attrs.template || 'shop-cart.component.html';
        // }]
    };

    angular.module('itxApp.common').component('itxShopCart', ItxShopCartCmp);

    ItxShopCartCmpCtrl.$inject = [
        '$rootScope',
        'ItxShopCartFct',
        'ItxLoaderFct',
        'imCheckoutService',
        'imCartService',
        'ShopCartPackagingService',
        'ItxTranslateSvc',
        'SaveForLaterService',
        'ItxLoginSvc',
        'ItxScreenSizeSvc',
        '$scope',
        'preCommonCmsConfigSvc',
        'ItxHeaderFct'
    ];

    function ItxShopCartCmpCtrl(
        $rootScope,
        ItxShopCartFct,
        ItxLoaderFct,
        imCheckoutService,
        imCartService,
        ShopCartPackagingService,
        ItxTranslateSvc,
        SaveForLaterService,
        ItxLoginSvc,
        ItxScreenSizeSvc,
        $scope,
        preCommonCmsConfigSvc,
        ItxHeaderFct
    ) {
        var _this = this;

        _this.showShopCartItems = true;
        _this.isMobile = ItxScreenSizeSvc.is('xs');

        _this.actionsAllowed = {
            events: {
                addToCart: 'add:shopcart',
                deleteToCart: 'delete:shopcart',
                addBuylater: 'add:buylater',
                deleteBuylater: 'delete:buylater',
                updateQuantity: 'update:quantity',
                updateSize: 'update:size'
            },
            translations: {
                delete: ItxTranslateSvc.translateCms('legacy.common.delete'),
                addToCart: ItxTranslateSvc.translateCms('legacy.common.addToCart'),
                buylater: ItxTranslateSvc.translateCms('legacy.saveForLater.button')
            }
        };

        _this.itemTypeBuyLater = {
            name: 'item-buylater',
            actions: [
                {
                    name: _this.actionsAllowed.events.addToCart,
                    text: _this.actionsAllowed.translations.addToCart,
                    isBuyable: true
                },
                {
                    name: _this.actionsAllowed.events.deleteBuylater,
                    text: _this.actionsAllowed.translations.delete
                }
            ]
        };

        _this.itemTypeShopcart = {
            name: 'item-shop-cart',
            actions: [{
                name: _this.actionsAllowed.events.deleteToCart,
                text: _this.actionsAllowed.translations.delete
            }]
        };

        _this._newWishEnabled = false;

        _this._buylaterTitle = 'legacy.saveForLater.title';
        _this._buylaterTitleMobile = 'legacy.saveForLater.title.mobile';

        _this.$onInit = function () {
            imTriggerPageview();
            ItxShopCartFct.haveIndomError();

            SaveForLaterService.isActive().then(function (buylater) {
                _this.buylater = buylater;

                if (buylater.enabled) {
                    _this.exitsApolloWishlist();
                    SaveForLaterService.getList().then(function (buylater) {
                        _this.buylater = buylater;
                    });

                    $rootScope.$on(buylater.event, function (e, buylater) {
                        if (buylater) {
                            _this.buylater = buylater;
                        } else {
                            _this.updateWishlistCount();
                        }
                    });
                } else {
                    $('#page').addClass('view-tab-cart');
                    $('#page').addClass('buylater-disabled');
                }
            });
        };

        _this.onAction = function (action, item, value) {
            switch (action) {
                case _this.actionsAllowed.events.deleteToCart:
                    _this.deleteItems([{
                        id: item.id,
                        quantity: 0
                    }]);
                    imCartService.itemQuantityChange(item, 0);
                    break;
                case _this.actionsAllowed.events.addToCart:
                    SaveForLaterService.addItemShopcart(item);
                    break;
                case _this.actionsAllowed.events.addBuylater:
                    if (_this._newWishEnabled) {
                        if (_this.isAuthenticated) {
                            SaveForLaterService.addItemList(item);
                            imCartService.saveForLater(item);
                        } else {
                            ItxLoginSvc.popupSignIn().then(function (res) {
                                // if (res.isAuthenticated) {
                                //     SaveForLaterService.addItemList(item);
                                //     imCartService.saveForLater(item);
                                // }
                            });
                        }
                    } else {
                        SaveForLaterService.addItemList(item);
                        imCartService.saveForLater(item);
                    }
                    break;
                case _this.actionsAllowed.events.deleteBuylater:
                    SaveForLaterService.deleteItemList(item);
                    imCartService.saveForLater(item, 0);
                    break;
                case _this.actionsAllowed.events.updateQuantity:
                    _this.updateQuantity(item, value);
                    imCartService.itemQuantityChange(item, value);
                    break;
                case _this.actionsAllowed.events.updateSize:
                    _this.updateSize(item, value);
                    break;
            }
        };

        _this.showCart = function () {
            _this.showShopCartItems = true;
            $('#page').addClass('view-tab-cart');
            $('#page').removeClass('view-tab-buylater');
            imTriggerPageview();
        };

        _this.updateWishlistCount = function () {
            _this.showShopCartItems = true;
            if (_this._newWishEnabled) {
                SaveForLaterService.getList().then(function (buylater) {
                    _this.buylater = buylater;
                });
            }
        };

        _this.exitsApolloWishlist = function () {
            preCommonCmsConfigSvc
                .getProperty('enable_wishlist')
                .then(function (wishEnabled) {
                    if (wishEnabled) {
                        _this._newWishEnabled = true;
                        _this._buylaterTitle = 'dev.cart.wishlist';
                        _this._buylaterTitleMobile = 'dev.cart.wishlist';
                        _this.itemTypeShopcart.actions.push({
                            name: _this.actionsAllowed.events.addBuylater,
                            text: ItxTranslateSvc.translateCms('dev.cart.addToWishlist')
                        });
                        _this.updateWishlistCount();
                    } else {
                        _this.itemTypeShopcart.actions.push({
                            name: _this.actionsAllowed.events.addBuylater,
                            text: _this.actionsAllowed.translations.buylater
                        });
                    }
                })
                .catch(function (err) {
                    console.error('Error getting CMS key: enable_wishlist ');
                    _this.itemTypeShopcart.actions.push({
                        name: _this.actionsAllowed.events.addBuylater,
                        text: _this.actionsAllowed.translations.buylater
                    });
                });
        };

        _this.showBuylater = function () {
            imTriggerPageview();
            // Hotjar user behavior analytics
            if (_this.isAuthenticated && typeof hj != 'undefined') {
                hj('tagRecording', ['wishlist']);
            }

            if (_this._newWishEnabled) {
                const options = {
                    bubbles: true,
                    composed: true,
                    detail: {
                        extra: {
                            typeEvent: 'wish'
                        }
                    }
                };
                document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
            } else {
                _this.showShopCartItems = false;
                $('#page').addClass('view-tab-buylater');
                $('#page').removeClass('view-tab-cart');
            }
        };

        _this.stockProblem = function (item) {
            return item.availability !== 'in_stock' || item.quantity > item.unitsAvailable;
        };

        _this.stockSort = function (item) {
            return !_this.stockProblem(item);
        };

        _this.deleteSubOrder = function (subOrderGroup) {
            var items = _.map(subOrderGroup.items, function (item) {
                return {
                    id: item.id,
                    quantity: 0
                };
            });
            _this.deleteItems(items);
        };

        _this.deleteItems = function (items) {
            ItxLoaderFct.show();
            ItxShopCartFct.updateCart(items).finally(function () {
                _this.updateShopCartCounter();
                ItxLoaderFct.hide();
            });
        };

        _this.onToggleGift = function (edit) {
            if (_this.shopCart.state.gift.giftSelected && !edit) {
                _this.deletePacking();
            } else {
                ShopCartPackagingService.openModalGift(_this.shopCart);
            }
        };

        _this.deletePacking = function () {
            ItxLoaderFct.show();
            ShopCartPackagingService.deleteGiftPacking(true)
                .then(function () {
                    ItxShopCartFct.getCart();
                    ItxLoaderFct.hide();
                })
                .catch(function () {
                    ItxLoaderFct.hide();
                });
        };

        _this.updateQuantity = function (item, quantity) {
            ItxLoaderFct.show();
            ItxShopCartFct.updateCart([{
                    id: item.id,
                    quantity: quantity
                }])
                .then(function () {})
                .finally(function () {
                    _this.updateShopCartCounter();
                    ItxLoaderFct.hide();
                });
        };

        _this.updateSize = function (item, value) {
            ItxLoaderFct.show();
            ItxShopCartFct.changeSize(item, value)
                .then(function () {})
                .catch(function () {})
                .finally(function () {
                    ItxLoaderFct.hide();
                });
        };

        _this.updateShopCartCounter = function () {
            const options = {
                bubbles: true,
                composed: true,
                detail: {
                    extra: {
                        typeEvent: 'update-shop-cart'
                    }
                }
            };
            document.dispatchEvent(new CustomEvent('legacy-event-apollo', options));
        };

        function imTriggerPageview() {
            if (!_this.showShopCartItems) {
                imCheckoutService.saveForLaterPageview(0);
            } else {
                imCheckoutService.createCartShop(inditex.iUserJSON.shopCart, 1);
            }
        }
    }
})();

// ONINIT
// if (_this.checkTailoring || _this.checkReturnableItems) {
//     _.each(_this.shopCart.items, function (item) {
//         if (_this.checkTailoring && item.itemType !== 1) {
//             _this.onlyTailoring = false;
//         }
//         if (_this.checkReturnableItems && !item.isReturnable) {
//             _this.hasNoReturnableItems = true;
//         }
//     });
// }

// hide tailoring personalization in checkout
// inditex.getXconfiguracionValue('ATTR_TAILORING_SHOWED', function (status, value) {
//     if (value) {
//         _this.attrTailoringShowed = value.split(',');
//         for (var i = 0; i < _this.attrTailoringShowed.length; i++) { _this.attrTailoringShowed[i] = parseInt(_this.attrTailoringShowed[i], 10); }
//         $timeout(function () {
//             $rootScope.$digest();
//         });
//     }
// });
// END onInit

// _this.setShopCart = function (shopCart) {
//     _this.shopCart = shopCart;
//     _this.onlyTailoring = true;
//     _.each(_this.shopCart.items, function (item) {
//         if (item.itemType !== 1) {
//             _this.onlyTailoring = false;
//         }
//     });
// };

// _this.toggleMoreInfo = function (item) {
//     if (_this.activeItem) {
//         if (_this.activeItem.id === item.id) {
//             _this.activeItem = null;
//         } else {
//             _this.activeItem = item;
//         }
//     } else {
//         _this.activeItem = item;
//     }
// };

// _this.getColorIndex = function (product) {
//     return _.findIndex(product.colors, function (color) {
//         return color.id === product.colorId;
//     });
// };

// _this.showAttr = function (attrId) {
//     return _.indexOf(_this.attrTailoringShowed, attrId) !== -1;
// };
